// cSpell:enableCompoundWords
import { HelmetImageName } from 'app/constants';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { HeaderLogo } from 'app/scenes/statsmanager/components/gamelogo/GameLogo';
import { setModalVisible } from 'app/slices/AppUiSlice';
import { getIsEditor } from 'app/slices/UserSlice';
import TopNavigation from 'components/topnavigation/TopNavigation';
import useSelectedScene from 'hooks/useSelectedScene';
import React from 'react';
import styles from './AppHeader.module.scss';

type AppHeaderProps = {
  className?: string;
};

const AppHeader: React.FC<AppHeaderProps> = ({ className = '' }) => {
  const baseCls = `${styles.AppHeader} ${className}`;
  const dispatch = useAppDispatch();
  const isEditor = useAppSelector(getIsEditor);
  const { setShowStatsForAllTeams, setStandingsActive, setShowLandingPage, setShowWeeklyGames } = useSelectedScene();
  const showUserAccountPanel = () => dispatch(setModalVisible(true));

  return (
    <div className={baseCls}>
      <HeaderLogo onManagerClick={() => undefined} logoUrl={HelmetImageName.Logo64} />
      <TopNavigation
        isEditor={isEditor}
        setShowLandingPage={setShowLandingPage}
        setShowStatsForAllTeams={setShowStatsForAllTeams}
        setStandingsActive={setStandingsActive}
        setShowWeeklyGamesPage={setShowWeeklyGames}
        showUserAccountPanel={showUserAccountPanel}
      />
    </div>
  );
};

export default AppHeader;
